import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";

/**
 * The legacy Play Store Readiness console is retired. Its old route
 * (#play-store-readiness / ?screen=play_store_readiness) lands here so a
 * stale link shows this notice instead of the old readiness content. The
 * console's files stay in the repo; they are no longer routed or bundled.
 */
export function PlayStoreReadinessRetired({ onBack }) {
  return (
    <CrewPilotModuleShell
      title="Play Store Readiness"
      subtitle="Retired"
      onBack={onBack}
      layout={PAGE_LAYOUT.COMMAND}
      compact
    >
      <section className="rec-card" data-testid="play-store-readiness-retired" style={{ padding: "20px" }}>
        <p style={{ margin: "0 0 16px", lineHeight: 1.55 }}>
          This legacy console has been retired and is no longer available.
        </p>
        <button type="button" className="nx-btn" onClick={onBack}>
          Back to Dashboard
        </button>
      </section>
    </CrewPilotModuleShell>
  );
}
